import { render, staticRenderFns } from "./ProductRequestInfo.vue?vue&type=template&id=4b711d9e"
import script from "./ProductRequestInfo.vue?vue&type=script&lang=js"
export * from "./ProductRequestInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports